import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['hablás un poco más lento', 'podés elegir una respuesta', 'el pecho deja de apretar', 'la mandíbula afloja', 'tu tono vuelve', 'tu mirada vuelve'];
  return <section className="py-20 md:py-32 px-6 bg-cream-200" data-id="element-15">
      <div className="max-w-2xl mx-auto mb-24" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-18">
            ¿Qué cambia cuando baja tu cuerpo?
          </h2>
          <p className="text-xl text-charcoal-light" data-id="element-19">
            No es que "te volvés zen". Es más real:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center bg-white p-4 rounded-lg shadow-sm" data-id="element-21">
              <Check className="w-5 h-5 text-terracotta mr-3 flex-shrink-0" data-id="element-22" />
              <span className="text-charcoal" data-id="element-23">{benefit}</span>
            </motion.div>)}
        </div>

        <p className="text-center text-xl font-serif italic text-charcoal" data-id="element-24">
          Y eso, en una casa real, es todo.
        </p>
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-lg border-t-4 border-terracotta" data-id="element-25">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-26">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-8 text-center" data-id="element-27">
            La mecánica única{' '}
            <span className="text-terracotta-dark font-normal italic text-xl block mt-2" data-id="element-28">
              (por qué esto funciona)
            </span>
          </h3>

          <p className="text-lg text-charcoal-light mb-10 leading-relaxed text-center" data-id="element-29">
            La mayoría intenta bajar desde la cabeza. Pero cuando estás
            activada, la cabeza explica… y el cuerpo manda. Este protocolo usa
            un puente directo:{' '}
            <span className="font-bold text-charcoal" data-id="element-30">
              tacto + ritmo + presión suave
            </span>{' '}
            en zonas que casi siempre están secuestradas por el estrés:
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-31">
            {[{
            num: '1',
            title: 'Oreja',
            desc: 'entrada sensorial que ayuda a bajar el estado'
          }, {
            num: '2',
            title: 'Mandíbula/Cuello',
            desc: 'zona de amenaza y contención'
          }, {
            num: '3',
            title: 'Pecho/Esternón',
            desc: 'armadura respiratoria'
          }].map((zone, i) => <div key={i} className="text-center p-4 bg-cream-100 rounded-xl" data-id="element-32">
                <div className="w-10 h-10 bg-terracotta text-white rounded-full flex items-center justify-center font-serif font-bold text-xl mx-auto mb-4" data-id="element-33">
                  {zone.num}
                </div>
                <h4 className="font-bold text-charcoal mb-2" data-id="element-34">{zone.title}</h4>
                <p className="text-sm text-charcoal-light" data-id="element-35">{zone.desc}</p>
              </div>)}
          </div>

          <div className="bg-cream-200 p-6 rounded-xl text-center" data-id="element-36">
            <p className="text-charcoal font-medium mb-4" data-id="element-37">
              Además, te doy algo que nadie te da:
              <br data-id="element-38" />
              <span className="text-terracotta-dark" data-id="element-39">
                señales físicas de que está funcionando
              </span>
              <br data-id="element-40" />
              <span className="text-sm text-charcoal-light font-normal" data-id="element-41">
                (bostezos, deglución, suspiros, calor, afloje)
              </span>
            </p>
            <p className="text-xl font-serif italic text-charcoal border-t border-terracotta/20 pt-4 mt-4 inline-block px-8" data-id="element-42">
              "Acá no adivinás. Lo sentís."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}